import PublicNavbar from "../components/PublicNavbar";
import Footer from "../components/Footer";

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-[#07090E]">
      <PublicNavbar />

      <section className="pt-32 pb-20 sm:pt-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1
            className="text-3xl sm:text-4xl font-bold text-white mb-8"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Mentions legales
          </h1>

          <div className="space-y-8 text-slate-300 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-semibold text-white mb-3">1. Editeur du site</h2>
              <p>Le site ServeurOnline est edite par :</p>
              <div className="mt-2 p-4 rounded-lg bg-[#0D111A] border border-slate-800/60">
                <p>ServeurOnline</p>
                <p>Email : contact@serveuronline.com</p>
                <p>Site web : https://serveuronline.com</p>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">2. Hebergement</h2>
              <p>Le site est heberge par un prestataire professionnel assurant la disponibilite et la securite des services. Les donnees sont hebergees dans des centres de donnees situes en Europe, conformement a la reglementation en vigueur.</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">3. Propriete intellectuelle</h2>
              <p>L'ensemble des contenus du site ServeurOnline (textes, images, graphismes, logo, icones, logiciels) est la propriete exclusive de ServeurOnline ou de ses partenaires et est protege par les lois francaises et internationales relatives a la propriete intellectuelle.</p>
              <p className="mt-2">Toute reproduction, representation, modification, publication, distribution, retransmission ou exploitation commerciale de quelque maniere que ce soit, totale ou partielle, des elements du site est strictement interdite sans l'autorisation ecrite prealable de ServeurOnline.</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">4. Responsabilite</h2>
              <p>ServeurOnline s'efforce de fournir des informations aussi precises que possible. Toutefois, il ne pourra etre tenu responsable des omissions, des inexactitudes et des carences dans la mise a jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.</p>
              <p className="mt-2">ServeurOnline est un outil de monitoring et ne se substitue pas a une solution de sauvegarde. L'utilisateur reste seul responsable de la mise en place et du bon fonctionnement de ses sauvegardes.</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">5. Conditions d'utilisation</h2>
              <p>L'utilisation du service ServeurOnline implique l'acceptation pleine et entiere des conditions generales d'utilisation decrites ci-apres. Ces conditions d'utilisation sont susceptibles d'etre modifiees ou completees a tout moment.</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400">
                <li>L'utilisateur s'engage a utiliser le service de maniere loyale et dans le respect de la legislation en vigueur.</li>
                <li>L'utilisateur est responsable de la confidentialite de ses identifiants de connexion.</li>
                <li>ServeurOnline se reserve le droit de suspendre ou supprimer tout compte utilise de maniere abusive.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-white mb-3">6. Droit applicable</h2>
              <p>Les presentes mentions legales sont soumises au droit francais. En cas de litige, les tribunaux francais seront seuls competents.</p>
            </div>

            <div className="pt-4 border-t border-slate-800/60">
              <p className="text-slate-500 text-xs">Derniere mise a jour : Fevrier 2026</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalNotice;
